import styled from "styled-components";

export const Content = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    background: cadetblue;
    border-radius: 10px;
    overflow: hidden;
    padding: 55px 55px 37px;

    .content_button {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .button {
            margin: 50px;
            font-size: 16px;
            color: #555;
            line-height: 1.2;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            min-width: 120px;
            height: 50px;
            border-radius: 25px;
            background: #fff;
            position: relative;
            z-index: 1;
            transition: all .4s;
        }
    }
`;

export const Logo = styled.span`
    font-size: 60px;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #fff;
`;

export const Title = styled.span`
    font-size: 30px;
    color: #fff;
    line-height: 1.2;
    text-align: center;
    text-transform: uppercase;
    display: block;
    margin: 20px;
`;
